import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { SearchItem } from "@/components/Store/StoreSearchInput/storeSearchInput.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

import { StoreSearchFilters } from "../filters/storeSearchFilters.container";
import { StoreSearchInput } from "../input/input.container";
import { SwitchTab } from "./switchTab/switchTab.container";

type StoreSearchControlsComponentProps = {
    selectedSearchItem?: SearchItem;
    filtersOpen: boolean;
    toggleFilters: () => void;
};

const _StoreSearchControlsComponent = ({
    filtersOpen,
    toggleFilters
}: StoreSearchControlsComponentProps) => {
    const { t } = useGranite();

    const { breakpoints } = useBreakpoint();

    return (
        <div
            className={cn(
                "tw:p-4 tw:rounded-md tw:bg-grey tw:flex tw:flex-col tw:mb-4 tw:items-start tw:gap-4",
                { "tw:min-h-full": filtersOpen }
            )}
        >
            <section className={cn("tw:w-full tw:[text-align-last:left]")}>
                <StoreSearchInput />
            </section>
            <section
                className={cn(
                    "tw:w-full tw:[text-align-last:left] tw:flex tw:gap-4"
                )}
            >
                <Button
                    className={cn("tw:flex tw:justify-between tw:items-center")}
                    fullWidth={true}
                    type={"button"}
                    color={"gray"}
                    onClick={toggleFilters}
                >
                    <span>
                        <i className={"las la-filter la-lg pr-2"}></i>
                        {t("form.searchstore.filteron")}
                    </span>
                    <i
                        className={cn("las la-angle-down la-lg", {
                            "tw:rotate-180": filtersOpen
                        })}
                    ></i>
                </Button>
                {!breakpoints.md && <SwitchTab />}
            </section>
            {filtersOpen && (
                <>
                    <section
                        className={cn(
                            "tw:w-full tw:[text-align-last:left] tw:h-full tw:max-h-full tw:grow tw:shrink tw:basis-auto tw:overflow-y-auto tw:bg-white tw:rounded-md tw:py-2 tw:px-0"
                        )}
                    >
                        <StoreSearchFilters />
                    </section>
                    <section
                        className={cn("tw:w-full tw:[text-align-last:left]")}
                    >
                        <Button
                            type={"button"}
                            onClick={toggleFilters}
                            color={"primary"}
                            fullWidth={true}
                            className={cn("tw:flex tw:justify-center")}
                        >
                            {t("form.searchstore.applyFilters")}
                        </Button>
                    </section>
                </>
            )}
        </div>
    );
};

export const StoreSearchControlsComponent = withBreakpoints(
    _StoreSearchControlsComponent
);
